// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Input,
  Select,
  DatePickerField,
} from "../../../../../../_metronic/_partials/controls";

// Validation schema
const CustomerEditSchema = Yup.object().shape({
  customerTaxId: Yup.string()
    .min(9, "Minimum 9 symbols")
    .max(10, "Maximum 10 symbols")
    .required("taxId is required"),
  customerName: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
  grace: Yup.string().required("Grace is required"),
  customerCode: Yup.string()
    .min(2, "Minimun 2 symbols")
    .required("customer code is required"),
  // dateOfBbirth: Yup.mixed()
  //   .nullable(false)
  //   .required("Date of Birth is required"),
  // ipAddress: Yup.string().required("IP Address is required"),
});

export function CustomerEditForm({
  saveCustomer,
  customer,
  actionsLoading,
  onHide,
}) {
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={customer}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          saveCustomer(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* taxId */}
                  <div className="col-lg-3">
                    <Field
                      name="customerTaxId"
                      component={Input}
                      placeholder="Tax ID"
                      label="Tax ID"
                      disabled={customer.customerTaxId != undefined}
                    />
                  </div>
                  {/*  name */}
                  <div className="col-lg-3">
                    <Field
                      name="customerName"
                      component={Input}
                      placeholder="Name"
                      label="Name"
                    />
                  </div>
                  {/* customer Code */}
                  <div className="col-lg-3">
                    <Field
                      name="customerCode"
                      component={Input}
                      placeholder="customer Code"
                      label="customer Code"
                    />
                  </div>
                  <div className="col-lg-3">
                    <Field
                      type="number"
                      name="grace"
                      component={Input}
                      placeholder="Payment (Days)"
                      label="Payment terms (Days)"
                    />
                  </div>
                </div>
                {/* grace */}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="submit"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
              >
                Save
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
